/**
 * Customer start-date selection window: today … today + 6 months.
 */

export function toLocalIsoDate(date) {
    const d = date instanceof Date ? date : new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function startOfLocalDay(date = new Date()) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
}

/** Inclusive max selectable start date (today + 6 calendar months). */
export function maxStartDate(from = new Date()) {
    const d = startOfLocalDay(from);
    d.setMonth(d.getMonth() + 6);
    return d;
}

export function getStartDateRange(from = new Date()) {
    const min = startOfLocalDay(from);
    const max = maxStartDate(from);
    return {
        minDate: toLocalIsoDate(min),
        maxDate: toLocalIsoDate(max),
        minDateObj: new Date(min),
        maxDateObj: new Date(max),
    };
}

export function isStartDateInRange(isoDate, from = new Date()) {
    if (!isoDate) return false;
    const { minDate, maxDate } = getStartDateRange(from);
    return isoDate >= minDate && isoDate <= maxDate;
}
